import $ from 'jquery';
import Section from '../Section';

export default class ShopTheLook extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    let getDots = this.element.querySelectorAll('.stl__dot--container');

    const setActiveItem = (el) => {
      // Remove the active class from sibling dots and add active class to the currently selected dot
      removeActiveClassFromMultipleEls('stl__dot--active');
      el.parentElement.blur();
      el.parentElement.classList.add('stl__dot--active');

      // Fade the inactive products and remove the fade class from the selected product
      addClassToMultipleEls('.stl__products', 'stl__product--faded');
 
      const activeProduct = this.element.querySelector(`[data-stl-product-block-id="${el.dataset.stlDotBlockId}"]`);
      removeClassFromSingleEl(activeProduct, 'stl__product--faded');
      scrollToActiveProduct(activeProduct);
    }

    const deselectActiveItem = (el) => {
      if (!el.hasAttribute("data-index")) {
        removeActiveClassFromMultipleEls('stl__dot--active');
        removeActiveClassFromMultipleEls('stl__product--faded');
      }
    }

    const blockSelectHandler = (e) => {
      const getBlockItem = this.element.querySelector(`[data-stl-dot-block-id="${e.detail.blockId}"]`);
      setActiveItem(getBlockItem);
    }

    const blockDeselectHandler = () => {
      removeActiveClassFromMultipleEls('stl__dot--active');
      removeActiveClassFromMultipleEls('stl__product--faded');
    }

    const removeActiveClassFromMultipleEls = (activeClass) => {
      const getActiveItems = this.element.querySelectorAll(`.${activeClass}`);
      getActiveItems.forEach(item => item.classList.remove(`${activeClass}`));
    }

    const addClassToMultipleEls = (els, classToAdd) => {
      const getEls = this.element.querySelectorAll(`${els}`);
      getEls.forEach(item => item.classList.add(`${classToAdd}`));
    }

    const removeClassFromSingleEl = (el, classToRemove) => el.classList.remove(`${classToRemove}`);

    const scrollToActiveProduct = (activeProduct) => {
      if (window.innerWidth < 768) activeProduct.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }

    if (getDots.length > 0) {
      document.addEventListener('click', (e) => deselectActiveItem(e.target));

      if (window.Shopify.designMode) {
        document.addEventListener('shopify:block:select', blockSelectHandler);
        document.addEventListener('shopify:block:deselect', blockDeselectHandler);
      }

      getDots.forEach(dot => {
        dot.addEventListener('click', (e) => setActiveItem(e.target));
        dot.addEventListener('keypress', (e) => {if (e.keyCode === 13) setActiveItem(e.target)});
      });
    }
  }
}
